import { customSequenceTypes } from '../../constants/retention';
import * as api from '../../api/retention';
import { dashboardRetentionEventFilterActions } from '../../constants/filter';
import { asyncAction } from '../common';
import { errorHandlerUnitsQueries } from './dashboards';

export const executeDashboardRetentionComplex = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_RETENTION_COMPLEX_QUERY',
    api.executeDashboardRetentionComplexQuery(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const changeRetentionComplexView = (unitId, view) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_COMPLEX_VIEW',
  unitId,
  view,
});

export const toggleRetentionTrendLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_TREND_LINE',
  unitId,
});

export const toggleRetentionAverageLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_AVERAGE_LINE',
  unitId,
});

export const toggleRetentionMedianLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_MEDIAN_LINE',
  unitId,
});

export const toggleRetentionAdaptive = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_ADAPTIVE',
  unitId,
});

export const changeFirstEvent = (unitId, event, eventMetainf) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_COMPLEX_FIRST_EVENT',
  unitId,
  event,
  eventMetainf,
});

export const changeReturnEvent = (unitId, event, eventMetainf) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_COMPLEX_RETURN_EVENT',
  unitId,
  event,
  eventMetainf,
});

export const changeDimensionType = (unitId, dimensionType) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_COMPLEX_DIMENSION_TYPE',
  unitId,
  dimensionType,
});

export const addFilterClause = (unitId, eventIndex) => ({
  type: dashboardRetentionEventFilterActions.ADD_FILTER_CLAUSE,
  unitId,
  eventIndex,
});

export const removeFilterClause = (unitId, eventIndex, id) => ({
  type: dashboardRetentionEventFilterActions.REMOVE_FILTER_CLAUSE,
  unitId,
  id,
  eventIndex,
});

export const setFilterClauseField = (unitId, eventIndex, id, field, type) => ({
  type: dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_FIELD,
  unitId,
  id,
  field,
  eventIndex,
  fieldType: type,
});

export const setFilterClauseValue = (unitId, eventIndex, id, value) => ({
  type: dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_VALUE,
  unitId,
  id,
  value,
  eventIndex,
});

export const setClausesConcatOperator = (unitId, eventIndex, value) => ({
  type: dashboardRetentionEventFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  unitId,
  value,
  eventIndex,
});

export const setFilterClauseOperator = (unitId, eventIndex, id, value, resetClauseValue) => ({
  type: dashboardRetentionEventFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  unitId,
  id,
  value,
  resetClauseValue,
  eventIndex,
});

export const toggleCustomSequence = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
  unitId,
});

export const setCustomSequenceType = (unitId, customSequenceType) => (dispatch) => {
  dispatch({
    type: 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TYPE',
    unitId,
    customSequenceType,
  });

  if (customSequenceType === customSequenceTypes.RANGE) {
    dispatch({
      type: 'DASHBOARD_CALCULATE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
      unitId,
    });
  }
};

export const changeCustomSequence = (unitId, customSequence) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
  unitId,
  customSequence,
});

export const setCustomSequenceFrom = (unitId, from = 0) => ({
  type: 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_FROM',
  unitId,
  from,
});

export const setCustomSequenceTo = (unitId, to = 0) => ({
  type: 'DASHBOARD_SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TO',
  unitId,
  to,
});

export const calculateCustomSequence = (unitId) => ({
  type: 'DASHBOARD_CALCULATE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
  unitId,
});

export const setFilterVisibility = (unitId, eventIndex, value) => ({
  type: dashboardRetentionEventFilterActions.SET_FILTER_VISIBILITY,
  unitId,
  eventIndex,
  value,
});

export const removeFilter = (unitId, eventIndex) => ({
  type: dashboardRetentionEventFilterActions.REMOVE_FILTER,
  unitId,
  eventIndex,
});

export const copyFilter = (unitId, eventIndex, clauses) => ({
  type: dashboardRetentionEventFilterActions.COPY_FILTER,
  unitId,
  eventIndex,
  clauses,
});

export const setRetentionComplexExposureError = (unitId, error) => ({
  type: 'DASHBOARD_SET_RETENTION_COMPLEX_EXPOSURE_ERROR',
  unitId,
  error,
});
